import { parseISO, subMonths } from "date-fns";
import type { SeasonalEvent } from "integrations/firebase/collections/seasonalEvents";
import {
  displayWindowEnd,
  getLeadTimeDays,
  getLeadTimeLabel,
  type LeadTimeLabel,
} from "components/seasonalEvents/calendarUtils";
import { getNextOccurrenceStart } from "components/seasonalEvents/utils";

export interface UpcomingSeasonalEvent {
  event: SeasonalEvent;
  start: string;
  leadTime: LeadTimeLabel;
}

export const getUpcomingEvents = (
  events: SeasonalEvent[],
  today: string,
): UpcomingSeasonalEvent[] => {
  const todayDate = parseISO(today);
  return events
    .flatMap((event) => {
      const start = getNextOccurrenceStart(event, today);
      if (!start || start > displayWindowEnd(today)) {
        return [];
      }
      // Not worth surfacing yet: still ahead of the event's own lead-in window.
      if (subMonths(parseISO(start), event.lead_time_months) > todayDate) {
        return [];
      }
      return [
        {
          event,
          start,
          leadTime: getLeadTimeLabel(getLeadTimeDays(start, today)),
        },
      ];
    })
    .sort(
      (a, b) =>
        a.start.localeCompare(b.start) ||
        a.event.display_name.localeCompare(b.event.display_name),
    );
};
